import { ca } from '@cian/analytics';

import { EDealFeatureCardTypes } from '../../types/promoInfo';

export function trackDealFeatureModalShow(featureCardType: EDealFeatureCardTypes) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSalePromo',
    action: 'Show_sopr',
    label: {
      [EDealFeatureCardTypes.InOffice]: 'popup_your_office',
      [EDealFeatureCardTypes.Remotely]: 'popup_anywhere',
      [EDealFeatureCardTypes.InVtbBank]: 'popup_vtb',
      [EDealFeatureCardTypes.SameDayDeal]: 'popup_today',
      [EDealFeatureCardTypes.WithAccessibility]: 'popup_disabled',
      [EDealFeatureCardTypes.WithMortgage]: 'popup_mortgage',
    }[featureCardType],
  });
}
